module.exports = __webpack_public_path__ + "static/media/xiangyang.e1941a02.png";